import React, { useEffect, useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  MenuItem,
  TextField,
  Toolbar,
  Typography,
  Grid,
  Paper,
  InputLabel,
  Select,
  FormControl,
  Snackbar,
} from "@material-ui/core";
import { Skeleton, Alert } from "@material-ui/lab";
import fileDownload from "js-file-download";
import GetAppIcon from "@material-ui/icons/GetApp";
import RefreshIcon from "@material-ui/icons/Refresh";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import TablePaginationActions from "../utils/TablePaginationActions";
import ServicesContext from "../../contexts/servicesContext";
import moment from "moment";
import { SendOutlined } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  toolbar: {
    display: "flex",
    flexDirection: "row",
  },
  title: {
    flex: "1 1 100%",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  formControl: {
    minWidth: "100%",
  },
  fioInput: {
    minWidth: "100%",
    height: "100%",
    "& .MuiInputBase-root": {
      height: "100%",
    },
  },
  buttonGroup: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    "& button": {
      marginRight: "10px",
    },
  },
  buttonGroup2: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "100%",
    "& button": {
      marginRight: "10px",
    },
  },
}));

function AetResultList() {
  const rowsPerPage = 20;
  const [currentPage, setCurrentPage] = useState(0);
  const [regions, setRegions] = useState();
  const [dates, setDates] = useState([]);
  const [date, setDate] = useState();
  const [regionId, setRegionId] = useState("");
  const [dateId, setDateId] = useState("");
  const dayjs = require("dayjs");
  const [loading, setLoading] = useState(true);
  const [loadingGetResultButton, setLoadingGetResultButton] = useState(false);
  const [results, setResults] = useState([]);
  const [resultsCount, setResultsCount] = useState(0);
  const [forAstana, setForAstana] = useState();

  const [searchQuery, setSearchQuery] = useState("");

  const classes = useStyles();
  const services = useContext(ServicesContext);

  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const resetFilter = () => {
    setRegionId("");
    setDateId("");
    setSearchQuery("");
    setCurrentPage(0);
  };

  useEffect(() => {
    setLoading(true);
    services.aet.getAllRegions().then((response) => {
      setRegions(response.data);
    });
    services.aet.getAllDates().then((response) => {
      setDates(response.data);
    });
    const debouncedSearch = setTimeout(() => {
      if (regionId === 1) {
        setForAstana(true);
      } else {
        setForAstana(false);
      }

      services.aet
        .getResultsByFilter({
          applicationYear: localStorage.getItem("AdmissionOfYear"),
          regionId: regionId,
          dateId: dateId,
          page: currentPage,
          keyword: searchQuery.replace(/\s/g, ""),
        })
        .then((response) =>
          setResults(() => {
            const { list, total_number } = response.data;
            setResultsCount(total_number);
            setLoading(false);
            return list;
          })
        );
    }, 1500);

    return () => clearInterval(debouncedSearch);
  }, [
    regionId,
    dateId,
    searchQuery,
    currentPage,
    services,
    localStorage.getItem("AdmissionOfYear"),
  ]);

  useEffect(() => {
    setDate(dates.find((obj) => obj.id === dateId));
    var obj = dates.find((obj) => obj.id === dateId)
    if (obj) {
      var inputDate = new Date(obj.date).getTime() + 17 * 60 * 60 * 1000
      var currentDate = new Date().getTime()
      setLoadingGetResultButton(currentDate > inputDate)
    }
  }, [dateId]);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleSearchQueryChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(0);
  };

  const getExcelFile = () => {
    services.aet
      .getExcelResults({
        applicationYear: localStorage.getItem("AdmissionOfYear"),
        regionId: regionId,
        dateId: dateId,
        keyword: searchQuery.trim(),
      })
      .then((response) => fileDownload(response.data, "AET-Results.xlsx"));
  };

  const getResultsFromAetModule = () => {
    if (date.id) {
      setLoading(true);
      services.aet
        .getResultFromAetModulByDateId(date?.id)
        .then((response) =>
          setResults(() => {
            const { list, total_number } = response.data;
            setResultsCount(total_number);
            setLoading(false);
            return list;
          })
        )
        .finally(() => {
          services.aet.getAllDates().then((response) => {
            setDates(response.data);
            setDate();
            setDate(response.data.find((obj) => obj.id === dateId));
          });
          setLoading(false);
        });
    }
  };

  const handleChooseRegion = (event) => {
    setRegionId(event.target.value);
    setCurrentPage(0);
  };

  const handleChooseDate = (event) => {
    setDateId(event.target.value);
    setCurrentPage(0);
  };
  return (
    <Paper className={classes.paper}>
      <Toolbar>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              className={classes.title}
              variant="h6"
              id="tableTitle"
              component="div"
            >
              Результаты AET
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item lg={6} xs={12}>
                <TextField
                  placeholder="Введите ваш запрос (ФИО или ИИН)"
                  value={searchQuery}
                  onChange={(event) => handleSearchQueryChange(event)}
                  className={classes.fioInput}
                />
              </Grid>
              <Grid item lg={3} xs={6}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="region-select">По региону</InputLabel>
                  <Select
                    labelId="region-select"
                    id="region-select-standard"
                    value={regionId}
                    onChange={handleChooseRegion}
                    label="По региону"
                  >
                    <MenuItem value="none">
                      <em>-</em>
                    </MenuItem>
                    <MenuItem value={1}>Астана</MenuItem>
                    <MenuItem value={2}>Другие регионы</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item lg={3} xs={6}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="date-select">По дате</InputLabel>
                  <Select
                    labelId="date-select"
                    id="date-select-standard"
                    value={dateId}
                    onChange={handleChooseDate}
                    label="По дате"
                  >
                    <MenuItem value="none">
                      <em>-</em>
                    </MenuItem>
                    {dates
                      ?.filter((date) => date.forAstana === forAstana)
                      .map((date) => (
                        <MenuItem value={date.id} key={date.id}>
                          {dayjs(date.date).format("DD-MM-YYYY HH:mm")}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item lg={6} xs={6}>
                <div className={classes.buttonGroup}>
                  <Button
                    variant="outlined"
                    onClick={resetFilter}
                    size="small"
                    startIcon={<RefreshIcon />}
                  >
                    Сбросить фильтр
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={getExcelFile}
                    color="primary"
                    startIcon={<GetAppIcon />}
                    size="small"
                  >
                    Скачать в excel
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      services.epvo.syncWithEpvo()
                        .then(() => handleClick())
                    }}
                    color="primary"
                    startIcon={<SendOutlined />}
                    size="small"
                  >
                    Отправить всех в ЕПВО
                  </Button>
                  <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={open} autoHideDuration={6000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                      Успешно отправлено!
                    </Alert>
                  </Snackbar>
                </div>
              </Grid>

              <Grid item lg={6} xs={6} sx={{ justifyContent: "flex-end" }}>
                <div className={classes.buttonGroup2}>
                  {date?.results === true ? (
                    <Alert severity="success" size="small" sx={{}}>
                      Результаты обновлены!
                    </Alert>
                  ) : null}
                  {(date?.results === false || date?.results === null) &&
                    loadingGetResultButton ? (
                    <Button
                      variant="outlined"
                      onClick={getResultsFromAetModule}
                      color="primary"
                      startIcon={<AutorenewIcon />}
                      size="small"
                    >
                      Получить результаты
                    </Button>
                  ) : null}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>

      <Table aria-label="custom pagination table">
        <TableHead>
          <TableRow>
            <TableCell>ФИО</TableCell>
            <TableCell>ИИН</TableCell>
            <TableCell>Регион</TableCell>
            <TableCell>Дата и время</TableCell>
            <TableCell>Международные сертификаты по английскому языку (IELTS, TOEFL IBT, TOEFL ITP, APTIS,
              InterPress, AITU iQyn,)</TableCell>
            <TableCell>Сертификат олимпиады (AITU iCode, AITU Open,
              Жаутыковской или Евразийской олимпиады) </TableCell>
            <TableCell>Оценка по английскому языку</TableCell>
            <TableCell>Оценка по ИКТ</TableCell>
          </TableRow>
        </TableHead>

        {loading ? (
          <TableBody>
            {[...Array(10)].map((x, i) => {
              return (
                <TableRow key={i}>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        ) : (
          <TableBody>
            {results?.map((result) => (
              <TableRow key={result?.id}>
                <TableCell component="th" scope="row">
                  {result?.surname +
                    " " +
                    result?.name +
                    " " +
                    (result?.patronymic ? result?.patronymic : "")}
                </TableCell>
                <TableCell component="th" scope="row">
                  {result?.iin}
                </TableCell>
                <TableCell component="th" scope="row">
                  {result?.region}
                </TableCell>
                <TableCell component="th" scope="row">
                  {dayjs(result?.requestDate).format("DD-MM-YYYY HH:mm")}
                </TableCell>
                <TableCell component="th" scope="row">
                  {result?.englishCertificate ? "Есть" : "Нет"}
                </TableCell>
                <TableCell component="th" scope="row">
                  {result?.olympiadCertificate ? "Есть" : "Нет"}
                </TableCell>
                <TableCell component="th" scope="row">
                  {result?.engResult ? result?.engResult : "-"}
                </TableCell>
                <TableCell component="th" scope="row">
                  {result?.iktResult ? result?.iktResult : "-"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
      <TablePagination
        count={resultsCount}
        rowsPerPage={rowsPerPage}
        page={currentPage}
        component="div"
        rowsPerPageOptions={[]}
        onChangePage={handleChangePage}
        ActionsComponent={TablePaginationActions}
      />
    </Paper>
  );
}

export default AetResultList;
